<template>
  <div class="extra-voyage-settings">
    <NavigationSection />
    <CostsSection />
    <ConstraintsSection />
  </div>
</template>

<script>
import ConstraintsSection from "./components/ConstraintsSection.vue";
import CostsSection from "./components/CostsSection.vue";
import NavigationSection from "./components/NavigationSection.vue";

export default {
  components: {
    NavigationSection,
    CostsSection,
    ConstraintsSection,
  },
  name: "ExtraVoyageSettings",
};
</script>

<style scoped>
.extra-voyage-settings {
  background-color: var(--color-bg);
  border-radius: 10px;
  border: 1px solid var(--color-secondary);
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}
</style>

